export const deleteLocalAndSessionStorageAndCookies = () => {
  localStorage.clear();
  sessionStorage.clear();
  const cookies = document.cookie;
  for (let i = 0; i < cookies.split(';').length; i += 1) {
    const myCookie = cookies[i];
    const pos = myCookie.indexOf('=');
    const name = pos > -1 ? myCookie.substr(0, pos) : myCookie;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  }
};

export async function forceLogOutAndCleanCache(): Promise<void> {
  try {
    const forceCache = localStorage.getItem('forceLogOut');
    if (forceCache === '1') {
      return;
    }
    // Attempt to clear all service workers and their caches
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        await registration.unregister();
      }
    }

    // Clear all caches (including those used by service workers)
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }

    // Clear local and session storage
    localStorage.clear();
    sessionStorage.clear();

    // Set the forceLogOut flag after clear
    localStorage.setItem('forceLogOut', '1');

    // Attempt to remove all accessible cookies (cannot clear 3rd-party cookies from JS)
    document.cookie.split(';').forEach((cookie) => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax`;
    });

    // Final step: reload the page
    window.location.reload();
  } catch (error) {
    console.error('Error during forced logout and cache cleanup:', error);
    // Still force reload just in case
    localStorage.setItem('forceLogOut', '1');
    window.location.reload();
  }
}
